import React from "react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "atropos/css";
import store from "./redux/store";
import { Provider } from "react-redux";
import PinMatch from "./app/PinMatch/PinMatch";
import InvoiceGenerator from "./app/InvoiceGenerator";

let findMyAccess = null;

const accessPath = localStorage.getItem("yesIAmFind");

const decode = (str) => {
  return decodeURIComponent(escape(atob(str)));
};
if (accessPath) {
  findMyAccess = decode(accessPath);
}

ReactDOM.render(
  <BrowserRouter>
    {findMyAccess === "IAmMjAccessUserFind" ? (
      <Provider store={store}>
        {/* <InvoiceGenerator /> */}
        <App />
      </Provider>
    ) : (
      <PinMatch />
    )}
  </BrowserRouter>,
  document.getElementById("root"),
);
